import {AcceptTermsConditions} from '../accept-terms-conditions/accept-terms-conditions';
import {connectApi} from './connect-api';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from "rxjs/index";
import { SESSION_STORAGE_KEYS } from '../common/session-storage-keys';
import {AcceptTermsConditionsDto} from '../accept-terms-conditions/accept-terms-conditions-dto';
import {map} from 'rxjs/internal/operators';
import {User} from './user';

@Injectable()
export class AcceptTermsConditionsService {

    constructor(private http: HttpClient) {
    }

    getTermsAndConditions(): Observable<AcceptTermsConditions> {
        return this.http
            .get<AcceptTermsConditions>(connectApi.termsAndConditions)
            .pipe(map(res => new AcceptTermsConditions(res['TermsAndConditions'])));
    }

    setupTermsAndConditions(acceptTermsConditionsDTO: AcceptTermsConditionsDto): Observable<User> {
        let accountId = sessionStorage.getItem(SESSION_STORAGE_KEYS.customerAccountId);
        let url = connectApi.setTermsAndConditions.replace('{accountId}', accountId);

        return this.http
            .put(url, acceptTermsConditionsDTO)
            .pipe(map(res => new User( res['User'])));
    }
}
